/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AssessmentDefinitionListSortCriteria {
    getFixupPrototypeFunction() { return AssessmentDefinitionListSortCriteria.fixupPrototype; }

    static newInstance(model: Partial<AssessmentDefinitionListSortCriteria>): AssessmentDefinitionListSortCriteria {
        let obj = Object.assign(new AssessmentDefinitionListSortCriteria(), model);
        AssessmentDefinitionListSortCriteria.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AssessmentDefinitionListSortCriteria>): AssessmentDefinitionListSortCriteria {
        if (!model) return null;
        return AssessmentDefinitionListSortCriteria.newInstance(<AssessmentDefinitionListSortCriteria> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AssessmentDefinitionListSortCriteria) {
        if (!obj) return;

        models.AssessmentDefinitionListSortCriteria.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AssessmentDefinitionListSortCriteria): boolean {
        Object.setPrototypeOf(obj, AssessmentDefinitionListSortCriteria.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    column: models.AssessmentDefinitionListSortColumn;

    ascending: boolean;

}
